import { render, staticRenderFns } from "./ListErrors.vue?vue&type=template&id=0637a390&scoped=true&lang=html"
import script from "./ListErrors.vue?vue&type=script&lang=js"
export * from "./ListErrors.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0637a390",
  null
  
)

export default component.exports